import { Chip } from '@mui/material';
import PropTypes from 'prop-types';

import colors from 'common/constants/colors';

// POM-6600 — the facts the confirm step can state about a product or an NDC. The tag keys match
// core's NdcProductLinkTag.
export const LINK_FACT = {
  DEFAULT: 'DEFAULT',
  MATCHES_TYPED_NAME: 'MATCHES_TYPED_NAME',
  SAME_CODE: 'SAME_CODE',
  SAME_MANUFACTURER: 'SAME_MANUFACTURER',
  SAME_NAME_STRENGTH_FORM_PACK: 'SAME_NAME_STRENGTH_FORM_PACK',
};

export const LINK_FACT_LABELS = {
  [LINK_FACT.DEFAULT]: 'Default',
  [LINK_FACT.MATCHES_TYPED_NAME]: 'Matches the name you typed',
  [LINK_FACT.SAME_CODE]: 'Same code',
  [LINK_FACT.SAME_MANUFACTURER]: 'Same manufacturer',
  [LINK_FACT.SAME_NAME_STRENGTH_FORM_PACK]: 'Same name, strength, form and pack',
};

const LINK_FACT_COLORS = {
  [LINK_FACT.DEFAULT]: {
    bgcolor: colors.warningAmberLight,
    color: colors.warningAmberText,
    borderColor: colors.warningAmberBorder,
  },
  [LINK_FACT.MATCHES_TYPED_NAME]: {
    bgcolor: colors.warningAlertSurface,
    color: colors.warningAlertText,
    borderColor: colors.typedNameChipBorder,
  },
  [LINK_FACT.SAME_CODE]: {
    bgcolor: colors.selectedProductNavyTint,
    color: 'primary.main',
    borderColor: colors.selectedProductNavyTintBorder,
  },
  [LINK_FACT.SAME_MANUFACTURER]: {
    bgcolor: colors.sameManufacturerChipSurface,
    color: colors.sameManufacturerChipText,
    borderColor: colors.sameManufacturerChipBorder,
  },
  [LINK_FACT.SAME_NAME_STRENGTH_FORM_PACK]: {
    bgcolor: colors.sameNameStrengthFormPackChipSurface,
    color: colors.sameNameStrengthFormPackChipText,
    borderColor: colors.sameNameStrengthFormPackChipBorder,
  },
};

// isStruckThrough marks a fact that confirming will end, e.g. a default NDC about to be replaced.
const LinkFactChip = ({ fact, isStruckThrough }) => (
  <Chip
    size='small'
    variant='outlined'
    label={LINK_FACT_LABELS[fact]}
    sx={{
      ...LINK_FACT_COLORS[fact],
      height: 22,
      fontWeight: 600,
      ...(isStruckThrough ? { textDecoration: 'line-through', opacity: 0.75 } : {}),
    }}
  />
);

LinkFactChip.propTypes = {
  fact: PropTypes.oneOf(Object.values(LINK_FACT)).isRequired,
  isStruckThrough: PropTypes.bool,
};
LinkFactChip.defaultProps = {
  isStruckThrough: false,
};

export default LinkFactChip;
